export default {
  body: 400,
  heading: 700,
  bold: 700,
}
